'use strict';

angular.module('myApp.homepage', ['ngRoute'])

.config(['$routeProvider', function($routeProvider) {
  $routeProvider.when('/', {
    templateUrl: 'components/rides/rides.html',
    controller: 'ridesCtrl'
  });

}])

.controller('homepageCtrl', ['$scope','$rootScope','$timeout','$filter','$location','API',function($scope,$rootScope, $timeout,$filter,$location,API) {

     API.seDefaultData();   
     $scope.counter1 = 913340;
     $scope.target1 = 17599575;
    
  
        var updateCounter1 = function() {
          
            if($scope.counter1<$scope.target1)
                {
                  $scope.counter1=$scope.counter1+10000;
                    $timeout(updateCounter1, 100);
                }
            else
            {
               $scope.counter1=$scope.target1;
                // console.log($scope.counter);
              
             
            }
           
        };
    $filter('number')
    $scope.counter2=1;
    $scope.target2=39;
  
        var updateCounter2 = function() {
          
            if($scope.counter2<$scope.target2)
                {
                  $scope.counter2=$scope.counter2+1;
                    $timeout(updateCounter2, 3000);
                }
            else
            {
               $scope.counter2=$scope.target2;
                // console.log($scope.counter);
              
             
            }
           
        };

    $scope.counter3=11231;
    $scope.target3=4303595;
  
        var updateCounter3 = function() {
          
            if($scope.counter3<$scope.target3)
                {
                  $scope.counter3=$scope.counter3+6243;
                    $timeout(updateCounter3, 100);
                }
            else
            {
               $scope.counter3=$scope.target3;
                // console.log($scope.counter);
              
             
            }
           
        };

    $scope.counter4 = 1231;
    $scope.target4 = 85351;
  
        var updateCounter4 = function() {
          
            if($scope.counter4<$scope.target4)
                {
                  $scope.counter4=$scope.counter4+72;
                    $timeout(updateCounter4, 100);
                }
            else
            {
               $scope.counter4=$scope.target4;
                // console.log($scope.counter);
              
             
            }
           
        };

     $scope.scrollTo=function () {
          $('html, body').animate({
              scrollTop: $(".downloadBackground").offset().top - 100
          }, 1000);
     }
    var imgsrc = "images/pressmedia/";
    $scope.pressMediaObject = [
        {
            link:'https://techcrunch.com/2018/04/25/jugnoo-singapore-uber-void/',
            desc:"India’s Jugnoo adopts a unique take on ride-hailing to help fill Singapore’s Uber void",
            img: imgsrc +  'TechCrunch.png',
            date:new Date(2018,3,25),

            heading: 'Tech Crunch'
        },
        {
            link:'http://www.businessworld.in/article/Jugnoo-Launches-an-On-demand-3D-Printing-Store-Printo-/26-02-2018-141788/',
            desc:"Jugnoo Launches an On-demand 3D Printing Store 'Printo'",
            img: imgsrc +  'business_world_logo.png',
            date:new Date(2018,1,26),

            heading: 'Business World'
        },
        {
            link:'https://www.youtube.com/watch?v=c46sRt9bAWk',
            desc:"ET Now - Leaders of Tomorrow series featuring Jugnoo.",
            img: imgsrc +  'ET-Now.jpeg',
            date:new Date(2018,1,17),

            heading: 'ET Now'
        },
        {
            link:'https://m.dailyhunt.in/news/india/english/business+sandesh+english-epaper-bussanen/jugnoo+launches+its+business+tools+in+the+auto+expo+2018-newsid-81538255',
            desc:"Jugnoo launches its business tools in The Auto Expo",
            img: imgsrc +  'daily_hunt.png',
            date:new Date(2018,1,10),

            heading: 'Daily Hunt'
        },
        {
            link:'https://www.insightssuccess.in/jugnoo-providing-an-instant-access-to-reliable-and-affordable-service',
            desc:"Jugnoo: Providing an Instant Access to Reliable and Affordable Services",
            img: imgsrc +  'insights_logo.png',
            date:new Date(2018,1),

            heading: 'Insights Success'
        },
        {
            link:'https://www.covaipost.com/coimbatore/3-coimbatore-women-auto-drivers-awarded/',
            desc:"Jugnoo women drivers awarded ‘Women of achievement’ by Rotary Club of Monarks, Coimbatore",
            img: imgsrc +  'covai_post_logo.png',
            date:new Date(2018,0,24),

            heading: 'The Covai Post'
        },
        {
            link:'http://www.businessworld.in/article/Riding-On-India-s-Growth-Wave/18-01-2018-137687/',
            desc:"Riding On India’s Growth Wave - Samar Singla’s interview with BW Businessworld.",
            img: imgsrc +  'business_world_logo.png',
            date:new Date(2018,0,18),

            heading: 'Business World'
        },

        {
            link:'https://in.news.yahoo.com/jugnoo-announces-launch-cabs-chandigarh-113734399.html',
            desc:"Jugnoo announces launch of cabs in Chandigarh",
            img: imgsrc +  'I_5.png',
            date:new Date(2017,11,1),

            heading: 'Yahoo News'
        },
        {
            link:'https://thenortheasttoday.com/arunachal-pradesh-jugnoo-an-auto-hailing-app-gears-up-to-make-inroads-into-northeast-india-through-itanagar/',
            desc:"Jugnoo- an auto hailing app gears up to make inroads into Northeast India through Itanagar!",
            img: imgsrc + 'tnt-magazine-logon.png',
            date:new Date(2017,10,23),

            heading: 'The North East Today'
        },
        {
            link:'https://www.indianweb2.com/2017/11/13/jugnoo-delivers-pollution-masks-comes-rescue-delhiites/',
            desc:"Jugnoo Delivers Pollution Masks, Comes To The Rescue of Delhiites",
            img: imgsrc + 'indian-web-logo.png',
            date:new Date(2017,10,13),
            heading: 'Indain Web2'
        },

        {
            link:'http://www.business-standard.com/article/news-ani/jugnoo-introduces-concierge-service-fatafat-117110901182_1.html',
            desc:"Jugnoo introduces concierge service - Fatafat",
            img: imgsrc + 'business_standard.jpeg',
            date:new Date(2017,10,9),
            heading: 'Business Standard'
        },
        {
            link:'https://www.mid-day.com/articles/as-tomatoes-hit-rs-100-per-kg-chandigarh-hyper-local-transport-and-logistics-app-jugnoo-offers-re-1/18705160',
            desc:"Tomato Loot! Jugnoo Delivers Tomato At Just Re 1 Per Kg In Chandigarh",
            img: imgsrc + 'mid-day-logo.png',
            date:new Date(2017,10,2),
            heading: 'Mid Day'
        },
        {
            link:'https://www.outlookindia.com/newsscroll/jugnoo-adds-bicycles-to-its-delivery-vertical/1166308',
            desc:"Jugnoo adds bicycles to its delivery vertical ",
            img: imgsrc + 'outlook-logo.jpg',
            date:new Date(2017,9,11),
            heading: 'Outlook India'
        },
        {
            link:'https://www.thememo.com/2017/10/03/uber-for-tuk-tuks-jugnoo-ceo-samar-singla-taxi-apps-click-labs-tuktuk-apps/',
            desc:"How an Uber for tuk-tuks quietly took over the world",
            img: imgsrc + 'it-memo-logo.ico',
            date:new Date(2017,9,3),
            heading: 'The Memo'
        }
    ]



        $(window).scroll(function () { // remove "$"
          if(window.location.pathname.substring(1) == ""){
        var x= $(this).scrollTop();
       
        // console.log(x);
        // console.log($('#scroll').offset().top)
         
    if (  x >= $('#scroll').offset().top-($(window).height()+300)){
        updateCounter1();
        updateCounter2();
        updateCounter3();
        updateCounter4();
  }

          }

    });
    
    
 



/* $('#myCarousel').carousel({        
      interval: 3500
    })
  
 setTimeout(function(){
    jQuery("#owlone").owlCarousel({
       
    margin:0,
    autoWidth:true,

    smartSpeed: 1000,
    dots:false,
        mouseDrag: false,
  touchDrag: false,
  pullDrag: false,
        nav:true,

     
   navText: ["<img src='images/leftArrow.png'>","<img src='images/slider-arrow.png'>"],
        

  })
}, 0);*/
    
 
    
    setTimeout( function(){
     jQuery("#owltwo").owlCarousel({
           
        loop:true,
          margin:0,
         center:true,
         autoplay:true,
         dots:false,
        
    autoplayTimeout:3000,
         autoplaySpeed:1000,
    autoplayHoverPause:true,
    responsiveClass:true,
    responsive:{
        0:{
            items:2,
          
         },
        600:{
            items:3,
            
        },
        1000:{
            items:4,
           
            
        },
         1400:{
            items:5,
           
            
        }
    }
  })
  }, 0);
    
    
   
}]);